import templateUrl from './spotlightImage.html';

export const SpotlightImageComponent = {
    templateUrl,
    controller: function(restaurantInfoFactory) {
        'ngInject';
        restaurantInfoFactory.getInfo(['imageSet', 'onlineOrder']).then(info => this.restaurantInfo = info);
    }
};
